import request from '@/utils/request'

// 查询流量场景列表数据
export function findTrafficScenes(params) {
  return request({
    url: `/traffic_scenes`,
    method: 'get',
    params: params
  })
}

// 查询单个流量场景表单值
export function findTrafficSceneForm(id) {
  return request({
    url: `/traffic_scenes/${id}/form`,
    method: 'get'
  })
}

// 更新流量场景数据
export function updateTrafficScene(id, data) {
  return request({
    url: `/traffic_scenes/${id}`,
    method: 'put',
    data
  })
}

// 创建流量场景数据
export function createTrafficScene(data) {
  return request({
    url: `/traffic_scenes`,
    method: 'post',
    data
  })
}

// 更新流量场景有效性
export function batchUpdateTrafficScenesEffective(ids, effective) {
  const data = { ids: ids, effective: effective }
  return request({
    url: `/traffic_scenes/effective/batch`,
    method: 'patch',
    data
  })
}

// 查询流量场景选项数据（需传 carrier_type）
export function findTrafficSceneOptions(params) {
  return request({
    url: `/traffic_scenes/options`,
    method: 'get',
    params: params
  })
}
